import { render, staticRenderFns } from "./Carrier.vue?vue&type=template&id=6ea0f2c4&scoped=true"
import script from "./Carrier.vue?vue&type=script&lang=ts"
export * from "./Carrier.vue?vue&type=script&lang=ts"
import style0 from "./Carrier.vue?vue&type=style&index=0&id=6ea0f2c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea0f2c4",
  null
  
)

export default component.exports